import React, { useState } from "react"
import {
  Box,
  makeStyles,
  Typography,
} from "@material-ui/core"
import ScanHistoryTable from "../../table/scanHistoryTable"
import {
  GetApp as GetAppIcon
} from '@material-ui/icons'
import { getLang } from "app/feature/constants";
import LoadingComponent from "components/loading";


const API_HOST = process.env.REACT_APP_API_HOST_URL;

const useStyles = makeStyles((theme) => ({
  container: {
    background: "white",
    borderRadius: 4,
    padding: "16px 20px",
    overflowX: "auto"
  },
}))

export default function ScanHistoryPanelComponent({ 
  scanHistory,
  isFetching,
  isError,
  handleChangePage,
  handleChangeRowsPerPage,
  page,
  rowsPerPage,
  totalFiltered,
  handleReload,
  paginationOptions,
  tableFilter,
  changeOrder,
  snScanLimit,
  enc,
  language,
  token,
  lang,
  handleViewDetail
}) {
  const classes = useStyles()
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    setIsExporting(true);
    const exportUrl = `${API_HOST}/consumer/export/v1/scan/${enc}?token=${token}`;

    try {
      // Fetch the data
      const response = await fetch(exportUrl);
      const blob = await response.blob();
      
      // Create anchor element and trigger download
      const a = document.createElement("a");
      a.download = `scan_history_${new Date().toISOString().slice(0,10)}.xlsx`;
      a.href = URL.createObjectURL(blob);
      a.addEventListener("click", () => {
        setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
      });
      a.click();
      setIsExporting(false);
    } catch (error) {
      console.error("Export failed:", error);
      setIsExporting(false);
    }
  };

  return (
    <>
      <Box className={classes.container} mt={2}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="body1"><b>{getLang(lang, "label.CONSUMER_SCAN_HISTORY")}</b></Typography>
          <Box position="relative">
            <GetAppIcon 
              fontSize="small" 
              style={{
                cursor: isExporting ? "default" : "pointer",
                opacity: isExporting ? 0.5 : 1
              }}
              onClick={isExporting ? null : handleExport}
            />
            {isExporting && (
              <Box position="absolute" top="-4px" left="-4px" width="24px" height="24px" display="flex" alignItems="center" justifyContent="center">
                <LoadingComponent height="auto" style={{ width: 16, height: 16 }} />
              </Box>
            )}
          </Box>
        </Box>
        <Box>
          <ScanHistoryTable 
            rows={scanHistory}
            isFetching={isFetching}
            isError={isError}
            handleReload={handleReload}
            page={page}
            rowsPerPage={rowsPerPage}
            language={language}
            totalFiltered={totalFiltered}
            paginationOptions={paginationOptions}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            tableFilter={tableFilter}
            changeOrder={changeOrder}
            snScanLimit={snScanLimit}
            lang={lang}
            handleViewDetail={handleViewDetail}
          />
        </Box>
      </Box>
    </>
  )
}
